import React, { useContext, useState, useEffect } from 'react'
import { SessionContext } from '../session-context'
import { parseISO } from 'date-fns'
import dateFormat from 'dateformat'
import CalendarCompleteIcon from '@material-ui/icons/EventAvailable'
import AgentAvatar from '../AgentAvatar'
import { calendarStyles } from './calendarHelpers'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { registerTextReminder } from '../js/data-providers'

function PhoneEntry (props) {
  const knownPhoneNumbers = []
  const data = props.completeEvent.attributes.data
  const visitorMobile = data.visitor_mobile_phone
  const visitorPhone = data.visitor_phone
  if (visitorPhone.replace(/\D/g, '').length >= 10) {
    knownPhoneNumbers.push(visitorPhone)
  }
  if (visitorMobile.replace(/\D/g, '').length >= 10) {
    knownPhoneNumbers.push(visitorMobile)
  }
  const [newPhone, setNewPhone] = useState(knownPhoneNumbers.length < 1)

  useEffect(() => {
    if (knownPhoneNumbers.length) {
      props.setPhone(knownPhoneNumbers[0])
    }
  }, [])

  function isValidInput (evt) {
    evt = (evt) || window.event
    const charCode = (evt.which) ? evt.which : evt.keyCode
    if ([40, 41, 43, 45, 32].includes(charCode)) {
      return true
    }
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault()
      return false
    }
    return true
  }

  function switchMode () {
    props.setPhone('')
    setNewPhone(true)
  }

  if (newPhone) {
    return (
      <TextField
        variant='outlined'
        label='Cell Phone Number'
        fullWidth
        style={{ marginTop: -5, marginBottom: 10 }}
        value={props.phone}
        onChange={props.handlePhone}
        onKeyPress={e => isValidInput(e)}
        autoFocus
      />
    )
  }

  return (
    <Select
      fullWidth
      variant='outlined'
      style={{ marginBottom: 10, marginTop: -5 }}
      value={props.phone}
    >
      <MenuItem value=''><div onClick={switchMode}>Enter a new number</div></MenuItem>
      {
        knownPhoneNumbers.map((number, index) => (
          <MenuItem value={number} key={index}>
            <div onClick={() => props.setPhone(number)}>{'Text me at ****** ' + number.replace(/\D/g, '').substr(number.length - 4)}</div>
          </MenuItem>
        ))
      }
    </Select>
  )
}

function ReminderSettings (props) {
  const { token, chatServiceUrl } = useContext(SessionContext)
  const [phone, setPhone] = useState('')
  const [reminderTime, setReminderTime] = useState(15)

  const handleSelect = (event) => {
    setReminderTime(event.target.value)
  }

  const handlePhone = (event) => {
    setPhone(event.target.value)
  }

  const menuItemStyles = {
    padding: '2px 15px',
    fontSize: '14px',
    minHeight: 36
  }
  return (
    <div>
      <PhoneEntry
        phone={phone}
        setPhone={setPhone}
        handlePhone={handlePhone}
        completeEvent={props.completeEvent}
      />
      <div style={{ display: 'grid', gridTemplateColumns: '3fr 1fr', gridGap: 10 }}>
        <Select
          variant='outlined'
          fullWidth
          renderValue={(value) => 'Remind me ' + value + ' minutes prior'}
          style={{ fontSize: '12px' }}
          value={reminderTime}
          onChange={handleSelect}
        >
          <MenuItem value={5} style={menuItemStyles}>Five Minutes Prior</MenuItem>
          <MenuItem value={10} style={menuItemStyles}>Ten Minutes Prior</MenuItem>
          <MenuItem value={15} style={menuItemStyles}>Fifteen Minutes Prior</MenuItem>
          <MenuItem value={30} style={menuItemStyles}>Thirty Minutes Prior</MenuItem>
        </Select>
        <Button
          variant='outlined'
          disabled={phone.replace(/\D/g, '').length < 10}
          onClick={() => registerTextReminder({
            calendarDropEventID: props.drop.event_id,
            reminderTime,
            phone,
            token,
            chatServiceUrl
          })}
        >
          Done
        </Button>
      </div>
      <div style={{ marginTop: 10 }}>
        <Button
          startIcon={<ArrowBackIcon style={{ fontSize: 15 }} />}
          onClick={props.handleBack}
          style={{ fontSize: '11px' }}
        >
          Back
        </Button>
      </div>
    </div>
  )
}

function ReminderPrompt (props) {
  const { token, chatServiceUrl } = useContext(SessionContext)
  const classes = calendarStyles()
  const [preference, setPreference] = useState(null)

  if (preference === 'yes') {
    return (
      <ReminderSettings
        handleBack={() => setPreference(null)}
        drop={props.drop}
        completeEvent={props.completeEvent}
      />
    )
  }

  return (
    <div>
      <div className={classes.textReminderPrompt}>
        Would you like a text reminder prior to your meeting?
      </div>
      <div className={classes.textReminderButtonDiv}>
        <Button
          variant='outlined'
          style={{ padding: '10px 0px', border: '1px solid rgba(0,0,0,0.8)' }}
          onClick={() => setPreference('yes')}
        >
          Yes, text me
        </Button>
        <Button
          variant='outlined'
          style={{ padding: '10px 0px', border: '1px solid rgba(0,0,0,0.8)' }}
          onClick={() => registerTextReminder({
            calendarDropEventID: props.drop.event_id,
            phone: null,
            reminderTime: null,
            token,
            chatServiceUrl
          })}
        >
          No thanks
        </Button>
      </div>
    </div>
  )
}

function TextReminderSection ({ firstName, completeDate, startTime, endTime, avatarUrl, drop, completeEvent }) {
  const classes = calendarStyles()
  return (
    <>
      <div className={classes.calendarDropCompleteCard} style={{ display: 'flex', padding: 10, marginBottom: 15 }}>
        <div style={{ marginRight: 10 }}>
          <AgentAvatar avatarUrl={avatarUrl} size={65} />
        </div>
        <div style={{ margin: 'auto' }}>
          <div style={{ fontSize: '1.1em' }}>{firstName}</div>
          <div className={classes.textReminderDate}>{completeDate}</div>
          <div style={{ color: 'rgba(0,0,0,0.8)', fontSize: '0.8em' }}>{startTime} - {endTime}</div>
          <div className={classes.textReminderEmailMessage}>We'll send an invite to your email!</div>
        </div>
      </div>
      <ReminderPrompt
        drop={drop}
        completeEvent={completeEvent}
      />
    </>
  )
}

function DropComplete (props) {
  const classes = calendarStyles()

  const completeEvent = props.completeEvent
  const startDate = parseISO(completeEvent.attributes.data.start)
  const endDate = parseISO(completeEvent.attributes.data.end)
  const completeDate = dateFormat(startDate, 'dddd, mmmm dS')
  const startTime = dateFormat(startDate, 'shortTime')
  const endTime = dateFormat(endDate, 'shortTime')
  const firstName = props.agentName.split(' ')[0]
  const noTextMessage = props.noTextMessage || false

  // console.log(props.completedTextReminder)

  let message = "We'll send an invite to your email!"
  let fontSize = '1em'
  let marginTop = 15
  if (props.completedTextReminder) {
    const reminderTime = props.completedTextReminder.attributes.data.reminder_time
    if (reminderTime) {
      fontSize = '.9em'
      marginTop = 10
      message = "We'll send an invite to your email and a reminder text " +
        reminderTime + ' minutes prior to the meeting!'
    }
  }

  return (
    <div className={classes.calendarDropOuter}>
      <div className={classes.calendarDropHeader} style={{ display: 'grid', gridTemplateColumns: '30px auto 30px' }}>
        <CalendarCompleteIcon />
        <span>Meeting Scheduled!</span>
      </div>
      <div className={classes.calendarDropComplete}>
        {props.completedTextReminder || noTextMessage
          ? (
            <>
              <div className={classes.calendarDropCompleteCard}>
                <div className={classes.calendarDropCompleteAvatar}>
                  <AgentAvatar avatarUrl={props.avatarUrl} size={70} />
                </div>
                <div style={{ fontSize: '1.1em', marginTop: 8 }}>Meeting with {firstName}</div>
                <div className={classes.calendarDropCompleteDate}>{completeDate}</div>
                <div style={{ color: 'rgba(0,0,0,0.6)', fontSize: '1.1em' }}>{startTime} - {endTime}</div>
              </div>
              <div style={{ textAlign: 'center', marginTop: marginTop, fontSize: fontSize }}>{message}</div>
            </>)
          : (
            <TextReminderSection
              firstName={props.agentName}
              completeDate={completeDate}
              startTime={startTime}
              endTime={endTime}
              avatarUrl={props.avatarUrl}
              drop={props.drop}
              completeEvent={props.completeEvent}
            />)}
      </div>
    </div>
  )
}

export default DropComplete
